<template>
  <div class="hp-manager-page-list-filter" style="margin-bottom:20px" :class="!cla?'':'cla'">
    <a-form v-if="!cla" @submit="handleSubmit" :form="form">

      <div>
        <template v-for="(f,i) in filter">
          <a-col :lg="8" :md="12" :sm="24" :key="i" v-if="f.type == 'input'">
            <a-form-item :label="`${f.name}`" :labelCol="{ span: 5 }" :wrapperCol="{ span: 18 }">
              <a-input :placeholder="`请输入${f.name}`" @keyup.enter.native="handleSubmit" v-decorator="[`${f.key}`]" />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="8" :md="12" :sm="24" :key="i" v-if="f.type == 'number'">
            <a-form-item :label="`${f.name}`" :labelCol="{ span: 5 }" :wrapperCol="{ span: 18 }">
              <a-input v-decorator="[`${f.key}`]" />
            </a-form-item>
          </a-col>
          <a-col :lg="8" :md="12" :sm="24" :key="i" v-if="f.type == 'select'">
            <a-form-item :label="`${f.name}`" :labelCol="{ span: 5 }" :wrapperCol="{ span: 18 }">
              <a-select @change="`${f.change}`" :placeholder="`请选择${f.name}`" v-decorator="[`${f.key}`]">
                <template v-for="(i) in f.options">
                  <a-select-option :key="i.val" :value="i.val">{{i.name}}</a-select-option>
                </template>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :lg="8" :md="12" :sm="24" :key="i" v-if="f.type == 'cascader'">
            <a-form-item :label="`${f.name}`" :labelCol="{ span: 5 }" :wrapperCol="{ span: 18 }">
              <a-cascader @change="`${f.change}`" :options="f.options" :placeholder="`请选择${f.name}`" v-decorator="[`${f.key}`]"></a-cascader>
             
            </a-form-item>
          </a-col>
          <a-col :lg="8" :md="12" :sm="24" :key="i" v-if="f.type == 'date'">
            <a-form-item :label="`${f.name}`" :labelCol="{ span: 5 }" :wrapperCol="{ span: 18 }">
              <a-date-picker style="width:100%" v-decorator="[`${f.key}`]" />
            </a-form-item>
          </a-col>

          <a-col :lg="8" :md="12" :sm="24" :key="i" v-if="f.type == 'dateFilter'">
            <a-form-item :label="`${f.name}`" :labelCol="{ span: 5 }" :wrapperCol="{ span: 18 }">
              <date-filter @dateValueChange="dateValueChange" ref="dateFilter" v-decorator="[`${f.key}`]" />

            </a-form-item>
          </a-col>

          <a-col :lg="8" :md="12" :sm="24" :key="i" v-if="f.type == 'dateToSecendFilter'">
            <a-form-item :label="`${f.name}`" :labelCol="{ span: 5 }" :wrapperCol="{ span: 18 }">
              <date-filter showTime @dateToSecendValueChange="dateToSecendValueChange" ref="dateToSecendFilter" v-decorator="[`${f.key}`]" />
            </a-form-item>
          </a-col>

          <a-col :lg="8" :md="12" :sm="24" :key="i" v-if="f.type == 'rangedate'">
            <a-form-item :label="`${f.name}`" :labelCol="{ span: 5 }" :wrapperCol="{ span: 18 }">
              <a-range-picker :defaultValue="f.defaultValue" @change="rangeDateChange" v-decorator="[`${f.key}`]" />
            </a-form-item>
          </a-col>
        </template>
        <slot></slot>
        <a-col :span="20" :offset="2">
          <a-form-item>
            <a-button type="primary" @click="handleSubmit(0)">筛选</a-button>
            <a-button type="primary" @click="handleReset">重置</a-button>
            <a-button type="primary" @click="handleSubmit(1)" v-if="showExport">导出</a-button>
            <slot name='button'></slot>
            <slot name='tag'></slot>
          </a-form-item>

        </a-col>
        <a-col :span="2">
          <a @click="clachange" style="line-height:40px">收起条件</a>
        </a-col>
      </div>
    </a-form>
    <div v-if="cla">
      <a-col :span="24" :offset="22">
        <a @click="clachange" style="line-height:40px"> 展开搜索 </a>
      </a-col>
    </div>
    <div style="clear:both"></div>
  </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import dateFilter from "../form/dateFilter";
import dateToSecondFilter from "../form/dateToSecondFilter";
export default {
  name: "filterForm",
  components: {
    dateFilter,
    dateToSecondFilter
  },
  props: {
    filter: {
      type: Array,
      default() {
        return [];
      }
    },
    value: Object,
    showExport: Boolean
  },
  data() {
    return {
      form: this.$form.createForm(this),
      currentFilter: {},
      productType: {
        options: []
      },
      productTag: {
        options: [],
        loading: false
      },
      area: {
        options: [],
        loading: false
      },
      dateFilter: [null, null],
      rangeDateFilter: [null, null],
      dateToSecendFilter: [null, null],
      cla: false
    };
  },
  watch: {
    currentFilter() {
      this.$emit("input", this.currentFilter);
    }
  },
  mounted() {
    this.currentFilter = this.value;
    this.filter.find(f => {
      if (f.type == "rangedate") {
        if (f.defaultValue != null) {
          this.rangeDateFilter = f.defaultValue;
        }
      }
    });
  },
  methods: {
    clachange() {
      console.log(this.cla);
      this.cla = !this.cla;
    },
    dateValueChange(startVal, endVal) {
      this.dateFilter[0] = startVal == null ? startVal : startVal;
      this.dateFilter[1] = endVal == null ? endVal : endVal;
    },
    dateToSecendValueChange(startVal, endVal) {
      this.dateFilter[0] = startVal == null ? startVal : startVal;
      this.dateFilter[1] = endVal == null ? endVal : endVal;
    },
    rangeDateChange(obj, rangeDate) {
      this.rangeDate = rangeDate;
    },
    handleSubmit(type) {
      this.form.validateFields((err, values) => {
        let dt = this.filter.find(n => n.type === "dateFilter");
        if (dt) {
          Vue.set(values, dt.key, this.dateFilter);
        }

        let dt2 = this.filter.find(n => n.type === "rangedate");
        if (dt2) {
          Vue.set(values, dt2.key, this.rangeDateFilter);
        }
        let dt3 = this.filter.find(n => n.type === "dateToSecendFilter");
        if (dt3) {
          Vue.set(values, dt3.key, this.dateToSecendFilter);
        }
        if (type == 0) {
          this.$emit("handleSubmit", { values: values });
        } else if (type == 1) {
          this.$emit("handleExport", { values: values });
        }
      });
    },
    handleReset() {
      this.form.resetFields();
      let dt = this.filter.find(n => n.type === "dateFilter");
      let dt1 = this.filter.find(n => n.type === "dateToSecendFilter");
      if (dt) {
        this.$refs.dateFilter[0].reset();
      }
      if (dt1) {
        this.$refs.dateToSecendFilter[0].reset();
      }
    },
    getCurrentStyle(current, today) {
      const style = {};
      if (current.date() === 1) {
        style.border = "1px solid #1890ff";
        style.borderRadius = "50%";
      }
      return style;
    }
  }
};
</script>
<style lang="scss" scoped
>
.cla {
  height: 40px;
  padding: 0px;
}
</style>






// WEBPACK FOOTER //
// src/components/filter/filter.vue